import axiosInstance from '../services/AxiosInstance';
export function postInvoiceSettings(data) {
    return axiosInstance.post(`invoicesettings/add`, data);
}